import { useEffect, useRef, useState } from 'react';
import { ApiSearchWork, ApiSearchFavKeyword } from 'api/Search';
import { setKeywordData, getKeywordData, delKeywordData, initKeywordData } from 'utils/Storage';
import { SetState, GetState, useMemberInfo } from 'utils/State';

import Header from 'component/common/header/Header';
import MobileNav from 'component/common/nav/MobileNav';

import Footer from 'component/common/footer/Footer';
import TopBtn from 'component/common/button/top/TopBtn';

import SubNav from 'component/common/nav/SubNav';

// import './search.scss';
import style from './Search.module.scss';

import SearchKeyword from 'component/common/section/SearchKeyword';

import WorkTmpl from 'component/common/template/work/WorkTmpl';
import NoneTmpl from 'component/common/template/none/NoneTmpl';
import NoneSearchKeyword from 'component/common/template/none/NoneSearchKeyword';
import PopularKeywordTmpl from 'component/common/template/search/PopularKeywordTmpl';

import SearchKeywordModal from './component/SearchKeywordModal';
import { Link, useLocation, useParams } from 'react-router-dom';
import BookpalLink from 'component/common/custom/BookpalLink';


import img_search_white from 'assets/images/search/search_white.svg';
import img_hash_white from 'assets/images/search/hash_white.svg';


const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

function SearchClose(){

    const contentRef = useRef(null);

    const query = useQuery();

    const params = useLocation().state;



    const setState = SetState();
    const getState = GetState();
    const memberInfo = useMemberInfo();

    const isTooltip = getState.useGetTooltipSearch();

    const no_adult = query.get("no_adult");

    const [searchText, setSearchText] = useState(query.get("txt") ?? "");
    const [tab, setTab] = useState("all");
    const [arrTab, setArrTab] = useState(null);
    const [end, setEnd] = useState(false);
    const [keyword, setKeyword] = useState(params?.keyword ?? query.get("keyword") ?? null);

    // console.log(params);

    const [keywordList, setKeywordList] = useState([]);
    const [favKeyword, setFavKeyword] = useState([]);

    const saveMode = getState.useGetKeywordSaveMode() === false ? false : true;

    // const [keywordTab, setKeywordTab] = useState(null);

    const favKeywordSubmit = ApiSearchFavKeyword({
        onSuccess:(data)=>{
            if(data?.status === true){
                setFavKeyword(data?.result);
            }
        }
    })

    const [data, dataSubmit, initData, paging, setData, isLoading] = ApiSearchWork({
        bottomRef:contentRef,
        data:{
            title_writer: !!keyword ? null : searchText,
            category:arrTab,
            end:(end ? true : null),
            keyword:keyword,
            adult:(no_adult === "1" ? ['15']: null),
        },
        onError:()=>{
            dataSubmit();
        }
    });

    const saveModeToggle = ()=>{
        // console.log(saveMode)
        setState.setKeywordSaveMode(!saveMode);
    }

    const getKeywordSubmit = ()=>{
        setKeywordList(getKeywordData());
    }

    const searchTextSubmit = (searchText)=>{
        if(searchText?.trim() !== ""){
            setTab("all");
            setArrTab(null);
            setEnd(false);
            setKeyword(null);
            initData();
            dataSubmit();
            if(saveMode){
                setKeywordData(searchText?.trim());
            }
            getKeywordSubmit();
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'NumpadEnter') {

            if(searchText === ""){
                initSearch();
                return;
            }

            searchTextSubmit(searchText);
            e.target.blur();
        } else  {
            
        }
    };

    const initKeyword = () => {
        if(keyword !== null){
            setSearchText("");
            setTab("all");
            setArrTab(null);
            setEnd(false);
            setKeyword(null);
            initData();
        }
    }


    const initSearch = () => {
        setSearchText("");
        setTab("all");
        setArrTab(null);
        setEnd(false);
        setKeyword(null);
        initData();
    }

    

    const [showSearchKeywordModal, setShowSearchKeywordModal] = useState(false);

    const handlerToggleKeywordModal = () =>{
        setState.setTooltipSearch(true);
        setShowSearchKeywordModal(!showSearchKeywordModal);
    }

    

    useEffect(()=>{
        // console.log("end, arrtab")
        // console.log(searchText, keyword);
        // if(data && Array.isArray(data) && data?.length === 0){
        //     return;
        // }
        // console.log("searchText",searchText);
        // console.log("keyword",keyword);
        if(searchText !== "" || keyword !== null){
            console.log("init");
            initData();
            dataSubmit();
        }
    },[end,arrTab])

    useEffect(()=>{
        if(keyword !== null){
            setTab("all");
            setArrTab(null);
            setEnd(false);
            initData();
            dataSubmit();
        }
    },[keyword])
    
    useEffect(()=>{
        // console.log(tab);
        if(tab !== null){
            switch(tab){
                default:
                case "all":
                    setArrTab(null);
                    break;
                case "novel":
                    setArrTab(["novel"]);
                    break;
                case "toon":
                    setArrTab(["toon","comic"]);
                    break;
                case "epub":
                    setArrTab(["epub"]);
                    break;
            }
            // setEnd(false);
        }
    },[tab]);

    useEffect(()=>{
        getKeywordSubmit();
        favKeywordSubmit();
    },[])

// console.log(data, isLoading);
    return (
        <>
            <Header useMobile={false} />
            <MobileNav />
            {/* <!-- 서브메뉴 --> */}
            <SubNav 
                name="검색" 
                usePc={true} 
                useHome={true} 
                useMobile={true} 
                useBtnPrev={true}
                useBtnHome={true}
                setTop={'0px'} 
                setPcTop={'64px'}  
                />

            {/* <!-- //서브메뉴 --> */}
            <div id="container" className={"sub_wrap wrap " + style['container']} >
                

                {/* <!-- 검색시 나오기 전 화면 --> */}
                {data === null && isLoading === false ?
                    <>
                        <section className={"section recent_search wrapper s_wrap " + style['s_wrap'] + " " + style['recent_search']}>
                            
                            {saveMode ? 
                                <div className="tit_con clearfix">
                                    {/* <h2 className="title left color-txt-normal title-02-b text_overflow">최근 검색어</h2>
                                    <div className="right">
                                        <BookpalLink 
                                            onClick={(e)=>{
                                                initKeywordData();
                                                getKeywordSubmit();
                                            }}
                                        ><span className="color-btn-03-txt btn-03">전체 삭제</span></BookpalLink>
                                        <BookpalLink onClick={()=>saveModeToggle()}><span className="color-btn-03-txt btn-03">저장 기능 끄기</span></BookpalLink>
                                    </div> */}
                                </div>
                            :
                                <div className="tit_con clearfix">
                                    {/* <h2 className="title left color-txt-normal title-02-b text_overflow">최근 검색어</h2>
                                    <div className="right">
                                        <BookpalLink onClick={()=>saveModeToggle()}><span className="color-btn-03-txt btn-03">저장 기능 켜기</span></BookpalLink>
                                    </div> */}
                                </div>
                            }
                            
                            <p className="no_data small color-txt-04 body-02-long">서비스가 종료되었습니다.</p>
                            {/* <NoneSearchKeyword /> */}
                        </section>
                        
                    </>
                :null}

                
            </div>
            {/* <!-- container --> */}

            
            {/* <Footer /> */}
            <TopBtn />
        </>
    )
}

export default SearchClose;